import { HttpClient, RequestParams } from "@/utils/http-client";

export enum CourseTypeType {
  Course = "course",
  Marathon = "marathon",
  Astrology = "astrology",
  Arithmology = "arithmology",
  Mini = "mini",
}

enum ProductCurrencyType {
  Usd = "usd",
  Eur = "eur",
  Rub = "rub",
}

enum ProductStatusType {
  Active = "active",
  Incomplete = "incomplete",
  Unavailable = "unavailable",
}

enum ProductTypeType {
  Course = "course",
  Marathon = "marathon",
  Lesson = "lesson",
  Astrology = "astrology",
  AstrologyBundle = "astrology_bundle",
  MarathonBundle = "marathon_bundle",
  Subscription = "subscription",
  Bundle = "bundle",
  Resource = "resource",
  EventTicket = "event_ticket",
  EventBooking = "event_booking",
}

export interface CoursesListParamsType {
  /** course title contains substring */
  title?: string;
  /** type, one of enums values */
  type?: string;
  /** path, one of enums values */
  path?: string;
  /** universe, one of enums values */
  universe?: string;
  /** discipline, one of enums values */
  discipline?: string;
  /** skill */
  skill_area?: number;
  limit?: number;
  offset?: number;
  pro_supported?: boolean;
}

interface DisplayMediaBlockType {
  /** Extra images if needed */
  extra_images_urls?: string[];
  /** Absolute url of primary image */
  primary_image_url?: string;
  /** Absolute url of secondary image */
  secondary_image_url?: string;
  /** Absolute url of video */
  video_url?: string;
}

interface ProductType {
  course?: CourseType;
  course_id?: number;
  created_at?: string;
  currency?: ProductCurrencyType;
  deleted_at?: string;
  description?: string;
  exam_price_eur?: number;
  group_lesson_price_eur?: number;
  exam_price_rub?: number;
  group_lesson_price_rub?: number;
  group_lesson_count?: number;
  group_lessons_total_price?: number;
  html?: string;
  id?: number;
  lesson_id?: number;
  parent_id?: number;
  parent_product?: ProductType;
  price_eur?: number;
  price_pro_eur?: number;
  price_rub?: number;
  price_pro_rub?: number;
  products_bundle?: ProductType[];
  status?: ProductStatusType;
  title?: string;
  type?: ProductTypeType;
  upgrade_to_pro_price?: number;
}

interface LessonType {
  title?: string;
}

interface LessonBlockType {
  lessons?: LessonType[];
}

export enum PageMetaValueMetaType {
  Title = "title",
  Description = "description",
  Keywords = "keywords",
  OgTitle = "og:title",
  OgDescription = "og:description",
  OgImage = "og:image",
  OgUrl = "og:url",
  OgType = "og:type",
  TwitterCard = "twitter:card",
  TwitterUrl = "twitter:url",
  TwitterTitle = "twitter:title",
  TwitterDescription = "twitter:description",
  TwitterImage = "twitter:image",
}

export interface PageMetaValueType {
  meta?: PageMetaValueMetaType;
  value?: any;
}

enum CourseOptionsQuarterType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

interface CourseOptionsType {
  Quarter?: CourseOptionsQuarterType;
}

export interface CourseType {
  id?: number;
  title?: string;
  images?: DisplayMediaBlockType;
  html?: string;
  type?: CourseTypeType;
  slug?: string;
  group_lessons_count?: number;
  products?: ProductType[];
  lesson_blocks?: LessonBlockType[];
  tags?: string[];
  meta_values?: PageMetaValueType[];
  options?: CourseOptionsType;
  pro_supported?: boolean;
  modified_at?: string;
}

export interface RestErrorType {
  code?: number;
  data?: any;
  error?: string;
  message?: string;
}

export class Courses<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns courses list by filter, with limit/offset pagination, and total count in header
   *
   * @tags courses
   * @name CoursesList
   * @summary Get list of courses by filter
   * @request GET:/courses
   * @response `200` `(CourseType)[]` user info
   * @response `500` `void` error
   */
  coursesList = (query: CoursesListParamsType, params: RequestParams = {}) =>
    this.request<CourseType[], void>({
      path: `/courses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns course by slug
   *
   * @tags courses
   * @name CourseBySlug
   * @summary Get course by slug
   * @request GET:/courses/slug/{slug}
   * @secure
   * @response `200` `CourseType` course info
   * @response `500` `RestErrorType`
   */
  courseBySlug = (slug: string, params: RequestParams = {}) =>
    this.request<CourseType, RestErrorType>({
      path: `/courses/slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
